/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const DEFAULT_APP_CONFIG = {
  headers: {
    "x-org-id": "d063761a-358f-44ed-baaa-867bd8d1d519",
  },
  organization: {
    termsURL: "",
  },
  storeId: "635d814f2b18bf87f7a4e8ac",
  walletConnect: {
    relayURL: "https://walletbridge.vlinder.io/",
    persona: {
      signingDomain: {
        name: "Person",
        version: "1",
        verifyingContract: "0x0000000000000000000000000000000000000000",
      },
    },
  },
  servers: {
    graphql: [
      {
        name: "graphql-gateway",
        // url: "http://localhost:4000/",
        url: "https://staging-api-digicert.klefki.io/indus/core/v1/graphql/",
      },
    ],
    rest: {
      loginServer: {
        baseURL: "https://dev-dc.vlinder.io/vlinder-login/",
      },
    },
  },
  defaultLoading: {
    image: "https://s3.ap-south-1.amazonaws.com/io.vlinder.logos/10x.png",
    titleNormalText: "Loading",
    titleBoldText: "Page...",
    description: "This might take few seconds, Please wait !",
  },
  platformSemantics: {
    semantics: {
      holder: "Employee",
      holders: "Employees",
      issuer: "Organization",
    },
    Holders: {
      title: "Employees",
    },
    HoldersGroups: {
      title: "Employees Group",
    },
    DashboardIssuerAnalysis: {
      title: "Organization",
    },
  },
};
